((root, factory) => {
  const intelligence = factory();
  root.ForeFrontSearchIntelligence = intelligence;
  if (typeof module === 'object' && module.exports) module.exports = intelligence;
})(typeof self !== 'undefined' ? self : this, () => {
  'use strict';

  const PRINTERS = [
    { brand: 'Epson', model: 'CW-D3800', collection: '/collections/epson-cw-d3800-labels', aliases: ['d3800', '3800', 'cwd3800', 'cw d3800', 'epson d3800', 'colorworks d3800'], productHandles: ['epson-colorworks-cw-d3800-color-label-printer'] },
    { brand: 'Epson', model: 'CW-C4000', collection: '/collections/epson-cw-c4000-labels', aliases: ['4000', 'c4000', 'cwc4000', 'cw c4000', 'epson c4000', 'colorworks c4000'], productHandles: ['epson-colorworks-cw-c4000-color-label-printer'] },
    { brand: 'Epson', model: 'CW-C6000', collection: '/collections/epson-cw-c6000-labels', aliases: ['6000', '6000a', '6000p', 'c6000', 'c6000a', 'c6000p', 'cwc6000', 'cwc6000a', 'cwc6000p', 'cw c6000', 'cw c6000a', 'cw c6000p', 'epson c6000'], productHandles: ['epson-colorworks-cw-c6000a-4-color-label-printer-with-auto-cutter', 'epson-colorworks-cw-c6000p-4-color-label-printer-with-peel-and-present'] },
    { brand: 'Epson', model: 'CW-C6500', collection: '/collections/epson-cw-c6500-labels', aliases: ['6500', '6500a', '6500p', 'c6500', 'c6500a', 'c6500p', 'cwc6500', 'cwc6500a', 'cwc6500p', 'cw c6500', 'cw c6500a', 'cw c6500p', 'epson c6500'], productHandles: ['epson-colorworks-cw-c6500a-8-color-label-printer-with-auto-cutter', 'epson-colorworks-cw-c6500p-8-color-label-printer-with-peel-and-present'] },
    { brand: 'Epson', model: 'CW-C8000', collection: '/collections/epson-cw-c8000', aliases: ['8000', 'c8000', 'cwc8000', 'cw c8000', 'epson c8000', 'colorworks c8000'], productHandles: ['epson-colorworks-cw-c8000-color-label-printer'] },
    { brand: 'Epson', model: 'TM-C3400', collection: '/collections/epson-tm-c3400-labels', aliases: ['3400', 'c3400', 'tmc3400', 'tm c3400', 'epson 3400', 'epson c3400', 'colorworks 3400'] },
    { brand: 'Epson', model: 'TM-C3500', collection: '/collections/epson-tm-c3500-labels', aliases: ['3500', 'c3500', 'tm3500', 'tmc3500', 'tm c3500', 'tm c 3500', 'epson 3500', 'epson c3500', 'colorworks 3500'] },
    { brand: 'Epson', model: 'TM-C7500', collection: '/collections/epson-c7500-labels', aliases: ['7500', 'c7500', 'tm7500', 'tmc7500', 'tm c7500', 'epson c7500', 'colorworks 7500'] },
    { brand: 'Epson', model: 'TM-C7500G', collection: '/collections/epson-tm-c7500g-labels', aliases: ['7500g', 'c7500g', 'tm7500g', 'tmc7500g', 'tm c7500g', 'epson c7500g', 'colorworks 7500g'] },
    { brand: 'Primera', model: 'LX400', collection: '/collections/primera-lx400-labels', aliases: ['lx400', 'primera lx400'] },
    { brand: 'Primera', model: 'LX500', collection: '/collections/primera-lx500-labels', aliases: ['lx500', 'primera lx500'] },
    { brand: 'Primera', model: 'LX600', collection: '/collections/primera-lx600-labels', aliases: ['lx600', 'primera lx600'] },
    { brand: 'Primera', model: 'LX610', collection: '/collections/primera-lx610-labels', aliases: ['lx610', 'primera lx610'] },
    { brand: 'Primera', model: 'LX800', collection: '/collections/primera-lx800-labels', aliases: ['lx800', 'primera lx800'] },
    { brand: 'Primera', model: 'LX810', collection: '/collections/primera-lx810-labels', aliases: ['lx810', 'primera lx810'] },
    { brand: 'Primera', model: 'LX900', collection: '/collections/primera-lx900-labels', aliases: ['lx900', 'primera lx900'] },
    { brand: 'Primera', model: 'LX910', collection: '/collections/primera-lx910-labels', aliases: ['lx910', 'primera lx910'] },
    { brand: 'Primera', model: 'LX1000', collection: '/collections/primera-lx1000-labels', aliases: ['lx1000', 'primera lx1000'] },
    { brand: 'Primera', model: 'LX2000', collection: '/collections/primera-lx2000-labels', aliases: ['lx2000', 'primera lx2000'] },
    { brand: 'Primera', model: 'LX3000', collection: '/collections/primera-lx3000-labels', aliases: ['lx3000', 'primera lx3000'] },
    { brand: 'Primera', model: 'LX4000', collection: '/collections/primera-lx4000-labels', aliases: ['lx4000', 'primera lx4000'] },
    { brand: 'Afinia', model: 'L301', collection: '/collections/afinia-l301-labels', aliases: ['l301', 'afinia l301'] },
    { brand: 'Afinia', model: 'L501', collection: '/collections/afinia-l501-labels', aliases: ['l501', 'afinia l501'] },
    { brand: 'Afinia', model: 'L502', collection: '/collections/afinia-l502-labels', aliases: ['l502', 'afinia l502'] },
    { brand: 'Afinia', model: 'L701', collection: '/collections/afinia-l701-labels', aliases: ['l701', 'afinia l701'] },
    { brand: 'Afinia', model: 'L801', collection: '/collections/afinia-l801-labels', aliases: ['l801', 'afinia l801'] },
    { brand: 'Afinia', model: 'L901', collection: '/collections/afinia-l901-labels', aliases: ['l901', 'afinia l901'] },
    { brand: 'VIPColor', model: 'VP485', collection: '/collections/vipcolor-vp485-labels', aliases: ['vp485', 'vipcolor vp485', 'vip color vp485'] },
    { brand: 'VIPColor', model: 'VP495', collection: '/collections/vipcolor-vp495-labels', aliases: ['vp495', 'vipcolor vp495', 'vip color vp495'] },
    { brand: 'VIPColor', model: 'VP500', collection: '/collections/vipcolor-vp500-labels', aliases: ['vp500', 'vipcolor vp500', 'vip color vp500'] },
    { brand: 'VIPColor', model: 'VP550', collection: '/collections/vipcolor-vp550-labels', aliases: ['vp550', 'vipcolor vp550', 'vip color vp550'] },
    { brand: 'VIPColor', model: 'VP600', collection: '/collections/vipcolor-vp600-labels', aliases: ['vp600', 'vipcolor vp600', 'vip color vp600'] },
    { brand: 'VIPColor', model: 'VP610', collection: '/collections/vipcolor-vp610-labels', aliases: ['vp610', 'vipcolor vp610', 'vip color vp610'] },
    { brand: 'VIPColor', model: 'VP650', collection: '/collections/vipcolor-vp650-labels', aliases: ['vp650', 'vipcolor vp650', 'vip color vp650'] },
    { brand: 'VIPColor', model: 'VP660', collection: '/collections/vipcolor-vp660-labels', aliases: ['vp660', 'vipcolor vp660', 'vip color vp660'] },
    { brand: 'VIPColor', model: 'VP700', collection: '/collections/vipcolor-vp700-labels', aliases: ['vp700', 'vipcolor vp700', 'vip color vp700'] },
    { brand: 'VIPColor', model: 'VP750', collection: '/collections/vipcolor-vp750-labels', aliases: ['vp750', 'vipcolor vp750', 'vip color vp750'] },
    { brand: 'UniNet', model: 'iColor 200', collection: '/collections/inkjet-labels', aliases: ['icolor200', 'icolor 200', 'uninet icolor 200', 'unineticolor200'], generalCollection: true },
    { brand: 'UniNet', model: 'iColor 250', collection: '/collections/inkjet-labels', aliases: ['icolor250', 'icolor 250', 'uninet icolor 250', 'unineticolor250'], generalCollection: true }
  ];

  const WORD_CORRECTIONS = {
    epsom: 'epson', epsonns: 'epson',
    lable: 'label', lables: 'labels', labls: 'labels', labes: 'labels', lbls: 'labels', labeles: 'labels',
    glos: 'gloss', glose: 'gloss', glossy: 'gloss',
    bop: 'bopp', boppp: 'bopp', matt: 'matte', mattee: 'matte',
    maintance: 'maintenance', maintenence: 'maintenance', maintence: 'maintenance', maintainance: 'maintenance',
    cartrige: 'cartridge', cartriges: 'cartridges', cartidge: 'cartridge', cartidges: 'cartridges',
    continous: 'continuous', contiuous: 'continuous', continuos: 'continuous',
    ribon: 'ribbon', ribbion: 'ribbon', waterprof: 'waterproof', waterproff: 'waterproof',
    rewinderer: 'rewinder', unwindder: 'unwinder', stickes: 'stickers', stikers: 'stickers',
    sythetic: 'synthetic', syntetic: 'synthetic'
  };

  const normalizeSearchText = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const compact = (value) => normalizeSearchText(value).replace(/\s+/g, '');

  function editDistance(left, right) {
    const a = compact(left);
    const b = compact(right);
    const row = Array.from({ length: b.length + 1 }, (_, index) => index);
    for (let i = 1; i <= a.length; i += 1) {
      let previous = row[0];
      row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const saved = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1));
        previous = saved;
      }
    }
    return row[b.length];
  }

  function cleanQuery(raw) {
    const original = String(raw || '').trim();
    let cleaned = original.toLowerCase();
    if (cleaned.normalize) cleaned = cleaned.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    cleaned = cleaned.replace(/[\u2018\u2019]/g, "'").replace(/[\u201c\u201d]/g, '"').replace(/[\u00d7]/g, 'x').replace(/(\d)\s*x\s*(\d)/g, '$1 x $2');
    // Normalize units and material phrases while preserving printer/SKU separators.
    cleaned = cleaned.replace(/(\d)\s*[-\u2010-\u2015]\s*(?=(?:inches?\b|inch\b|in\b|mm\b))/g, '$1 ')
      .replace(/\b(matte|gloss)\s*[-\u2010-\u2015]\s*(paper|bopp)\b/g, '$1 $2');
    const corrections = [];
    cleaned = cleaned.replace(/[a-z]+/g, (word) => {
      const replacement = WORD_CORRECTIONS[word];
      if (!replacement || replacement === word) return word;
      corrections.push({ from: word, to: replacement });
      return replacement;
    });
    return { original, cleaned: cleaned.replace(/\s+/g, ' ').trim(), corrections };
  }

  function continuousLabelSpec(raw) {
    const words = ['one','two','three','four','five','six','seven','eight','nine','ten','eleven','twelve'];
    const text = cleanQuery(raw).cleaned.replace(/\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\b/g, (word) => String(words.indexOf(word) + 1));
    if (!/\bcontinuous\b/.test(text)) return null;
    const measured = text.match(/(\d+(?:\.\d+)?)\s*[-\u2010-\u2015]?\s*(inches|inch|in\b|mm\b|["″])/);
    const adjacent = text.match(/(?:^|[^\d.])(\d+(?:\.\d+)?)\s+(?:wide\s+)?continuous\b|\bcontinuous\s+(\d+(?:\.\d+)?)/);
    const width = measured ? Number(measured[1]) / (measured[2] === 'mm' ? 25.4 : 1) : adjacent ? Number(adjacent[1] || adjacent[2]) : null;
    return { width, finish: /\bmatte\b/.test(text) ? 'matte' : /\bgloss\b/.test(text) ? 'gloss' : '', material: /\bpaper\b/.test(text) ? 'paper' : /\bbopp\b|\bpolypropylene\b|\bsynthetic\b/.test(text) ? 'bopp' : '' };
  }

  function matchesContinuousLabel(item, spec) {
    if (!spec) return true;
    const candidate = continuousLabelSpec(item?.title || '');
    if (!candidate) return false;
    if (spec.width != null && (candidate.width == null || Math.abs(candidate.width - spec.width) > 0.015)) return false;
    if (spec.finish && candidate.finish !== spec.finish) return false;
    if (spec.material && candidate.material !== spec.material) return false;
    return true;
  }

  function brandHintFor(value) {
    if (/\bepson\b|\bcolorworks\b/.test(value)) return 'Epson';
    if (/\bprimera\b/.test(value)) return 'Primera';
    if (/\bafinia\b/.test(value)) return 'Afinia';
    if (/\bvip\s*color\b|\bvipcolor\b/.test(value)) return 'VIPColor';
    if (/\buninet\b|\bicolor\b/.test(value)) return 'UniNet';
    return '';
  }

  function printerAliases(printer) {
    return Array.from(new Set([...(printer.aliases || []), printer.model, printer.brand + ' ' + printer.model].filter(Boolean)));
  }

  function findPrinter(raw) {
    const cleaned = cleanQuery(raw).cleaned;
    const valueCompact = compact(cleaned);
    const brandHint = brandHintFor(cleaned);
    let best = null;

    PRINTERS.forEach((printer) => {
      if (brandHint && printer.brand !== brandHint) return;
      printerAliases(printer).forEach((alias) => {
        const aliasCompact = compact(alias);
        const numericOnly = /^\d+$/.test(aliasCompact);
        const exact = numericOnly
          ? new RegExp('(?:^|\\D)' + aliasCompact + '(?:\\D|$)').test(cleaned)
          : valueCompact.includes(aliasCompact);
        if (!exact) return;
        const score = aliasCompact.length + (brandHint ? 50 : 0) + (valueCompact === aliasCompact ? 30 : 0);
        if (!best || score > best.score) best = { ...printer, matchedAlias: alias, score };
      });
    });

    if (!best) {
      const tokens = normalizeSearchText(cleaned).split(' ').filter((token) => token.length >= 4);
      PRINTERS.forEach((printer) => {
        if (brandHint && printer.brand !== brandHint) return;
        printerAliases(printer).forEach((alias) => {
          const aliasCompact = compact(alias);
          if (aliasCompact.length < 4) return;
          const distance = Math.min(...tokens.map((token) => editDistance(token, aliasCompact)));
          if (distance > 1) return;
          const score = 20 - distance + (brandHint ? 50 : 0);
          if (!best || score > best.score) best = { ...printer, matchedAlias: alias, score };
        });
      });
    }

    if (!best) return null;
    delete best.score;
    return best;
  }

  function detectIntent(cleaned, printer) {
    const hasMaintenance = /(maintenance|waste\s*(?:ink\s*)?(?:box|tank)|sjmb)/.test(cleaned);
    const hasInk = /(\binks?\b|cartridges?|cmyk|ink\s*sets?|sjic)/.test(cleaned);
    const hasEquipment = /(rewinders?|unwinders?|label\s*holders?|applicators?|external\s*roll\s*holders?|accessories|equipment|take\s*up)/.test(cleaned);
    const hasLabels = /(blank\s*)?(?:labels?|stickers?|label\s*rolls?|roll\s*labels?|continuous\s*labels?|die\s*cut\s*labels?|media\s*rolls?)/.test(cleaned);
    const hasSize = /\d+(?:\.\d+)?\s*(?:x|by)\s*\d+(?:\.\d+)?/.test(cleaned);
    const hasMaterial = /(bopp|paper|polypropylene|synthetic|waterproof|gloss|matte|thermal)/.test(cleaned);
    const asksForPrinter = /(label\s*printer|colour\s*printer|color\s*printer|printer\s*system|printer\s*machine|buy\s*(?:a\s*)?printer|compare\s*printers?)/.test(cleaned);
    if (hasMaintenance && hasInk) return 'supplies';
    if (hasMaintenance) return 'maintenance';
    if (hasInk) return 'ink';
    if (hasEquipment) return 'equipment';
    if (hasLabels || hasSize || hasMaterial) return 'labels';
    if (printer || asksForPrinter) return 'printer';
    return 'general';
  }

  function requestedModel(printer, cleaned) {
    if (!printer) return '';
    if (printer.brand === 'Epson' && /^CW-C(?:6000|6500)$/.test(printer.model)) {
      const family = (printer.model.match(/\d{4}/) || [])[0];
      const variant = String(cleaned || '').toLowerCase().match(new RegExp('(?:cw[\\s-]*)?c?[\\s-]*' + family + '[\\s-]*([ap])(?=$|[^a-z])'));
      if (variant) return 'CW-C' + family + variant[1].toUpperCase();
    }
    return printer.model;
  }

  function analyzeQuery(raw) {
    const cleaned = cleanQuery(raw);
    const printer = findPrinter(cleaned.cleaned);
    const intent = detectIntent(cleaned.cleaned, printer);
    const model = requestedModel(printer, cleaned.cleaned);
    return { ...cleaned, printer, intent, requestedModel: model };
  }

  function canonicalPrinterQuery(analysis) {
    if (!analysis?.printer) return analysis?.cleaned || '';
    return analysis.printer.brand + ' ' + (analysis.requestedModel || analysis.printer.model);
  }

  function labelCollectionTitle(printer) {
    if (!printer) return '';
    if (printer.brand === 'Epson') return 'Epson ColorWorks ' + printer.model.replace(/^CW-/, '').replace(/^TM-/, 'TM-') + ' Labels';
    return printer.brand + ' ' + printer.model + ' Labels';
  }

  function classifyItem(item, resourceType) {
    if (resourceType === 'article' || resourceType === 'page') return 'content';
    const cleanUrl = String(item?.url || '').split('?')[0];
    const value = normalizeSearchText([item?.title, item?.type, item?.product_type, cleanUrl, item?.handle].filter(Boolean).join(' '));
    if (resourceType === 'collection') {
      if (/ink|cartridge|maintenance|toner|ribbon/.test(value)) return 'supplies';
      if (/label|roll|bopp|paper/.test(value)) return 'labels';
      if (/printer|colorworks/.test(value)) return 'printer';
      return 'content';
    }
    if (/rewinder|unwinder|take up|roll holder|applicator|equipment/.test(value)) return 'equipment';
    if (/maintenance|waste ink|waste box|waste tank|sjmb/.test(value)) return 'maintenance';
    if (/\bink\b|cartridge|cmyk|sjic|toner|ribbon/.test(value)) return 'ink';
    if (/\bprinter\b/.test(value) && !/ink|cartridge|maintenance|rewinder|unwinder|take up/.test(value)) return 'printer';
    if (/labels?|rolls?|bopp|paper|polypropylene|synthetic/.test(value)) return 'labels';
    return 'other';
  }

  function itemRelevance(item, analysis) {
    const cleanUrl = String(item?.url || '').split('?')[0];
    const value = compact([item?.title, item?.type, item?.product_type, cleanUrl, item?.handle].filter(Boolean).join(' '));
    const model = compact(analysis?.requestedModel || analysis?.printer?.model || '');
    const baseModel = compact(analysis?.printer?.model || '');
    let score = 0;
    if (model && value.includes(model)) score += 120;
    else if (baseModel && value.includes(baseModel)) score += 100;
    const digits = (baseModel.match(/\d+/) || [])[0];
    if (digits && value.includes(digits)) score += 45;
    if (normalizeSearchText(item?.title) === normalizeSearchText(analysis?.original)) score += 25;
    return score;
  }

  function resultOrder(intent) {
    if (intent === 'labels') return ['labels', 'supplies', 'printer', 'equipment', 'other', 'content'];
    if (intent === 'ink' || intent === 'maintenance' || intent === 'supplies') return ['supplies', 'printer', 'labels', 'equipment', 'other', 'content'];
    if (intent === 'equipment') return ['equipment', 'printer', 'supplies', 'labels', 'other', 'content'];
    return ['printer', 'supplies', 'labels', 'equipment', 'other', 'content'];
  }

  return {
    PRINTERS,
    WORD_CORRECTIONS,
    normalizeSearchText,
    compact,
    editDistance,
    cleanQuery,
    continuousLabelSpec,
    matchesContinuousLabel,
    printerAliases,
    findPrinter,
    detectIntent,
    analyzeQuery,
    canonicalPrinterQuery,
    labelCollectionTitle,
    classifyItem,
    itemRelevance,
    resultOrder
  };
});
